<template>
  <div>
    <div class="content contentTerms">
      <div class="mainDiv">
        <article class="main">
          <section class="topTitle">
            <img src="/static/img/work/argreementLogo.png" alt="">
            薄盒用户协议
          </section>
          <section class="intro bold">
            <h4 style="margin-bottom: 5px; ">尊敬的用户（“您”）：</h4>
            <p style="word-break: break-all;">
              欢迎您使用薄盒平台（包括薄盒APP，以下简称“本平台”），本平台由杭州邻科娱乐科技有限公司（以下简称“我们”）运营。本平台是一款为用户提供话术脚本的平台。使用我们的服务前请您仔细阅读以下条款，使用我们的服务则表明您已知悉并接受这些条款（以下简称“本协议”）。若您不接受有关条款和条件的约束，请立即停止使用我们的服务。<br />
            </p>
          </section>
          <section class="privacy-content">
            <ul>
              <li>
                <div class="rt">
                  <p>一、签约主体以及协议范围</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>1.1协议主体及范围</p>
                        <p class="desc" style="word-break: break-all;">
                          本协议是您与我们就使用本平台服务而共同订立的协议。<br>
                          本协议条款的效力及于我们所提供的一切产品和服务，您在享受本平台任何服务时，应当受本协议的约束。本协议项下的产品和服务是指由我们发布的包括但不限于网络媒体、互联网增值、互动娱乐、电子商务、广告等互联网产品和服务（形式包括但不限于视频、音频、评论、跟帖、弹幕、图片、软件、技术代码等）。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.2订立前提</p>
                        <p class="desc"><span class="bold">您在本平台不可用于非法行为，该等承诺与保证将作为您与我们订立本协议的前提。</span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.3免责条款</p>
                        <p class="desc"><span
                            class="bold">为了让您更好地使用我们提供的产品和服务，请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款。本协议中限制、免责条款可能以加粗形式提醒您注意。<br>当您注册/登录本平台，即视为您已充分阅读并接受本协议的所有条款，您同意本协议对您与我们双方具有法律约束力。
                          </span></p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>1.4协议组成部分</p>
                        <p class="desc">
                          除本协议明确规定外，对于我们发布的由著作权人或其他权利人销售的产品和服务，我们有权在本协议的基础上通过单独的产品和服务协议（以下简称“单项产品协议”）加以规范，您须在使用有关产品或服务时另行了解与确认。单项产品协议与本协议有冲突的地方，以单项产品协议为准。如您使用该产品或服务，即视为对相关单项产品协议的接受。<br />
                          本协议内容同时包括所有我们已经发布或未来可能发布的各类规则、公告或通知，以及您在使用某一特定产品或服务时同意的单项产品协议，前述规则、公告、通知和单项产品协议一经发布即为本协议不可分割的组成部分，对您和我们双方具有法律约束力。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.5协议的修订</p>
                        <p class="desc">
                          <span class="bold">
                            我们有权根据需要不时地修订本协议及/或各类规则（包括但不限于制定新的条款和修改既有条款），一旦发生变动，我们将尽可能及时地在平台上以在线公告的方式进行变更公告，而无须另行单独通知您。修订后的协议和规则一经公布，立即或在公告明确的特定时间生效。若您在前述公告修订后继续使用我们的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用本平台。
                          </span>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <div class="rt">
                  <p>二、我们的服务</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>2.1话术脚本的提示</p>
                        <p class="desc">
                          在您使用平台过程中，我们为您提供了脚本记录、展示、提醒等功能。您可以对您需要的话术脚本进行记录展示。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.2服务升级</p>
                        <p class="desc">
                          为增进用户体验、完善服务内容，我们将会改进、增强和进一步开发本平台的服务，您理解并同意，我们有权不向您特别通知而对本平台服务进行更新，或对本平台的部分功能进行改变或限制。</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>三、使用规范</p>
                  <p class="desc">
                    您有权享受本平台提供的互联网技术服务和信息服务。
                    <br>
                    <span class="bold">
                      在您遵守本协议的前提下，我们授予您关于本平台有限的非商业性使用的权利。在任何情形下，我们的内容及服务仅被许可由您个人使用而不得被出售或转让。我们保留本协议未特别授予的所有权利。您在使用我们的服务过程中，必须遵循以下原则：
                    </span>
                  </p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          3.1您不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利。本条所述内容是指您使用本协议项下服务过程中所制作、上载、复制、发布、传播的任何内容，以及其他使用账号或本平台服务所产生的内容。
                        </p>
                        <ul>
                          <li>
                            <div class="rt">（1）反对宪法所确定的基本原则的；</div>
                          </li>
                          <li>
                            <div class="rt">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</div>
                          </li>
                          <li>
                            <div class="rt">（3）损害国家荣誉和利益的；</div>
                          </li>
                          <li>
                            <div class="rt">（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</div>
                          </li>
                          <li>
                            <div class="rt">（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</div>
                          </li>
                          <li>
                            <div class="rt">（6）煽动民族仇恨、民族歧视，破坏民族团结的；</div>
                          </li>
                          <li>
                            <div class="rt">（7）破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
                          </li>
                          <li>
                            <div class="rt">（8）散布谣言，扰乱经济秩序和社会秩序的；</div>
                          </li>
                          <li>
                            <div class="rt">（9）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
                          </li>
                          <li>
                            <div class="rt">（10）侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；</div>
                          </li>
                          <li>
                            <div class="rt">（11）违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的。
                            </div>
                          </li>
                          <li>
                            <div class="rt">（12）相关法律法规或本协议、相关协议、规则等禁止的。</div>
                          </li>
                        </ul>
                        <p class="desc">同时，您应当防范和抵制制作、复制含有下列内容的不良信息：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）使用夸张标题，内容与标题严重不符的；</div>
                          </li>
                          <li>
                            <div class="rt">（2）炒作绯闻、丑闻、劣迹等的；</div>
                          </li>
                          <li>
                            <div class="rt">（3）不当评述自然灾害、重大事故等灾难的；</div>
                          </li>
                          <li>
                            <div class="rt">（4）有性暗示、性挑逗等易使人产生性联想的；</div>
                          </li>
                          <li>
                            <div class="rt">（5）展现血腥、惊悚、残忍等致人身心不适的；</div>
                          </li>
                          <li>
                            <div class="rt">（6）煽动人群歧视、地域歧视等的；</div>
                          </li>
                          <li>
                            <div class="rt">（7）宣扬低俗、庸俗、媚俗内容的；</div>
                          </li>
                          <li>
                            <div class="rt">（8）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；</div>
                          </li>
                          <li>
                            <div class="rt">（9）其他对网络生态造成不良影响的内容。</div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          3.2不得利用我们的服务从事违法犯罪的活动，包括分裂国家、教唆他人犯罪、侵犯计算机安全系统、干扰或扰乱网络服务等危害国家安全、欺诈、洗钱及从事或资助其他违法犯罪活动或有损社会公共利益的行为。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.3遵守本协议及所有相关的协议、规定和程序，同时也必须遵循与因特网有关的程序和惯例。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.4不得利用或针对我们的服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；</div>
                          </li>
                          <li>
                            <div class="rt">（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</div>
                          </li>
                          <li>
                            <div class="rt">（3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；</div>
                          </li>
                          <li>
                            <div class="rt">（4）使用未经许可的数据或进入未经许可的服务器/账号；</div>
                          </li>
                          <li>
                            <div class="rt">（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</div>
                          </li>
                          <li>
                            <div class="rt">（6）未经许可，企图探查、扫描、测试本服务系统或网络的弱点或其它实施破坏网络安全的行为；</div>
                          </li>
                          <li>
                            <div class="rt">（7）企图干涉、破坏本服务系统或平台的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</div>
                          </li>
                          <li>
                            <div class="rt">（8）伪造TCP/IP数据包名称或部分名称。</div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>3.5不得对本平台进行反向工程、反向汇编、编译或者以其他方式尝试发现本平台的源代码。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.6不得使用未经我们授权或许可的任何插件、外挂、系统或第三方工具对本服务的正常运行进行干扰、破坏、修改或施加其他影响。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          3.7请您保证对通过本平台制作、复制的任何内容享有合法权益，不得侵犯我们及我们关联公司、或其他任何第三方的专利权、著作权、商标权等知识产权、名誉权、隐私权或其他任何合法权益，或从事损害我们利益或对我们造成不利影响的行为。 <span
                            class="bold">若您账号中的内容发生权利纠纷或侵犯了任何第三方的合法权益，您需承担全部法律责任。</span></p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>3.8除非已遵守了本协议的其它规定或已取得了我们事先许可，您不得为任何目的从事或帮助他人从事以下行为：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）下载、复制、读取、采用、展示、分享、转发、传播、上载、出版、发行我们的服务内容；</div>
                          </li>
                          <li>
                            <div class="rt">（2）修改、编辑、整理、编排或以其他方式演绎我们的服务内容；</div>
                          </li>
                          <li>
                            <div class="rt">（3）转让、转售、出租我们的服务内容；</div>
                          </li>
                          <li>
                            <div class="rt">（4）采用包括但不限于特殊标识、特殊代码等任何形式的识别方法，自行或协助第三人对我们服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.9经我们书面事先许可后，您对我们相关服务的信息内容的分享、转发等行为，还应符合以下规范：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              （1）对抓取、统计、获得的相关搜索热词、命中率、分类、搜索量、点击率、阅读量等相关数据，未经我们事先书面同意，不得将上述数据以任何方式公示、提供、泄露给任何第三人；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （2）不得对本平台的源网页进行任何形式的任何改动，包括但不限于本平台的首页链接、广告系统链接等入口，也不得对本平台的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；</div>
                          </li>
                          <li>
                            <div class="rt">（3）应当采取安全、有效、严密的措施，防止我们的信息内容被第三方通过包括但不限于网络爬虫程序等任何形式进行非法获取；</div>
                          </li>
                          <li>
                            <div class="rt">（4）不得把相关数据内容用于我们书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用；</div>
                          </li>
                          <li>
                            <div class="rt">（5）用户向任何第三人分享、转发我们相关服务信息内容的行为，还应遵守我们为此制定的其他规范和标准。</div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          3.10为了保护数据安全，您不得从事包括但不限于以下行为，也不得为其提供便利：
                        </p>
                        <ul>
                          <li>
                            <div class="rt">
                              （1）未经其他用户明确同意，或在未向其他用户如实披露数据用途、使用范围等相关信息的情形下收集、复制、存储、使用或传输其他用户数据，侵害其他用户合法权益；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （2）将其他用户的个人信息用于任何未经用户及我们授权的用途；</div>
                          </li>
                          <li>
                            <div class="rt">（3）企图进行反射查找、跟踪、关联、挖掘、获取用户个人信息；</div>
                          </li>
                          <li>
                            <div class="rt">（4）通过各种程序、软件等抓取任何用户的信息或与本服务相关的任何信息、数据；</div>
                          </li>
                          <li>
                            <div class="rt">（5）未经我们授权使用任何第三方软件、插件、外挂、系统等查看、获取本服务中所包含的我们及我们合作伙伴或用户的任何相关信息、数据等内容；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （6）其他危害数据安全的行为。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>四、知识产权保护</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          对于本平台的相关内容，我们将根据以下规则保护我们和您的知识产权：</br>
                          4.1除另有约定外，本平台的内容、代码、数据等所有元素的所有权和所有法律权利、以及其中所有知识产品（包括但不限于、系统、方法、信息、代码、软件、服务、组织、内容、数据、技术、程序、网页、文字、图片、图表、外观、外观设计、简报、应用程序，和所有其他元素的汇编）的知识产权及本平台上相关数据的权利均属于我们所有。未经我们事先书面许可，您不能进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现我们的源代码，不能出租、出借、修改、链接、汇编、发表、出版、转载、复制、拷贝、出售、转售、访问、爬取、建立镜像站点或者使用任何部分的内容、数据、代码和外观设计。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          4.2我们尊重您的知识产权。为了向您提供我们的服务（例如：展示您上传的文字、语音、图片、视频、图文等），您同意授予我们一项全球的、免费的、可转让、非独占和不可撤销的权利，在不侵犯您商业秘密和个人信息的前提下，使用您在使用我们的服务中向我们提供或生成的所有信息和数据。除此之外，除非获得了您的同意，我们不会擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表您拥有知识产权的成果。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          4.3所有与本平台以及本平台内容相关的商标、服务标志、编号均为我们或我们许可方的专有财产。未经我们事先书面授权同意，您不得在世界任何国家和地区将本平台Logo等文字、图形及其组合，以及本平台的其他标识、商号、徽记、APP名称、网站名称、服务名称、服务标记以任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理上述标识的行为。如因您非法使用上述标识等给我们或他人造成损失的，由您承担全部法律责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          <span class="bold">
                            4.4您应尊重我们和第三方的知识产权和其他合法权利/权益，保证在使用本平台服务时上传的文字、图片、视频、软件以及表演等信息不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等合法权益，并保证在发生侵犯前述权益的违法事件时，保护我们及我们的雇员、股东、合作伙伴等免于因该等事件受到影响或损失。我们保留在您侵犯我们及/或其他第三方的合法权利/权益时终止向您提供服务并不退还任何款项的权利，您应自行承担全部赔偿责任，并且赔偿我们因此遭受的包括但不限于经济、企业商誉等损失。
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.5任何组织或个人认为本平台的内容侵犯其知识产权的，可通过info@mints.cn向我们提出书面权利通知和侵权的初步证据，我们将在收到知识产权权利人合格通知后依法尽快处理。
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>五、关于本软件</p>
                  <p class="desc">
                    5.1我们开发并按照本协议之约定授权您下载、安装、登录、使用薄盒软件（<span class="bold">“本软件”</span>）。
                    <br>您可以通过手机终端以APP的形式使用本软件，同时，我们会不断丰富您使用本软件的终端、形式等。当您使用本软件时，您应选择与您的终端、系统等相匹配的软件版本，否则，您可能无法正常使用本软件。
                  </p>
                  <p class="desc">
                    5.2我们授予您一项个人的、不可转让及非排他性的许可，以按照本协议及其他单项产品协议限定的范围和方式使用本软件。您且仅限于您个人，可为非商业目的在单一台终端设备上下载、安装、使用本软件。</p>
                  <p class="desc">5.3您可以直接从我们的官方网站，以及授权的第三方网站和应用分发平台获取本软件。</p>
                  <p class="desc bold">5.4如果您从未经我们授权的第三方获取本软件或与本软件名称相同的安装程序，我们无法保证该软件能够正常使用，并对因此给您造成的损失不负任何责任。</p>
                  <p class="desc">5.5我们可能为不同的终端、系统等开发不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。下载安装程序后，您需要按照该程序提示的步骤正确安装。</p>
                  <p class="desc">5.6如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助我们改进产品服务，请告知我们卸载的原因。</p>
                  <p class="desc">5.7为了增进用户体验、完善服务内容，我们可能不断努力开发新的服务，并为您不时提供软件更新。</p>
                  <p class="desc bold">5.8为了改善用户体验或提高服务安全性、保证功能的一致性等目的，我们有权对本软件进行更新，或者对本软件的部分功能效果、服务内容进行改变。</p>
                  <p class="desc">5.9本软件新版本发布后，旧版本的软件可能无法使用。我们不保证旧版本软件继续可用，也不保证继续对旧版本软件提供相应的客服和维护服务，请您随时核对并下载最新版本。</p>
                  <p class="desc">5.10本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
                  <p class="desc">
                    5.11本软件如果使用了第三方的软件或技术，我们将按照相关法规或约定，对相关的协议或其他文件，可能通过在本软件安装包特定文件夹中打包等形式进行展示，它们可能会以“软件使用许可协议”“授权协议”“开源代码许可证”或其他形式来表达。
                  </p>
                  <p class="desc">5.12前述相关协议或其他文件均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。<span
                      class="bold">如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、进行罚款或采取其他制裁措施，并要求我们给予协助，您应当自行承担法律责任。</span></p>

                </div>
              </li>
              <li>
                <div class="rt">
                  <p>六、个人信息保护政策</p>
                  <p class="desc">
                    我们非常重视和保护您的个人信息，制定了专门的<span class="bold"><a href="/otherPrivacypolicyAndroid"
                        style="color:#83878B;font-weight:bold">《薄盒隐私政策》</a></span>。在您使用我们提供的服务前，请您务必进行阅读。
                  </p>
                </div>
              </li>
              <li>
                <div class="rt">
                  <p>七、赔偿</p>
                  <p class="desc">
                    因您违反本协议而导致的任何第三方向我们或我们的关联方提出的索赔或请求，您应当承担赔偿责任，包括但不限于诉讼费用、律师费用、差旅费用、和解金额、罚款或生效法律文书中规定的损害赔偿金额、软件使用费等，且您应为我们抗辩或消除影响，保护我们不受损害。
                  </p>
                </div>
              </li>
              <li>
                <div class="rt bold">
                  <p>八、责任限制</p>
                  <p class="desc bold">请您知晓并理解，在以下情形中，我们不对由此给您造成的任何损失或损害承担任何责任：</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          8.1我们将尽力为您提供畅通无阻、连贯安全的网络服务，但网络服务可能受多种因素的影响，我们不能保证向您提供的服务是连续的、即时的、准确的，也不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失、钱包文件损坏以及其他的损失和风险。我们的服务内容将依现状提供，我们不作任何形式的有关服务内容的准确性、完整性、令人满意的品质、不侵权或适合某一特殊目的的保证。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          8.2我们保留随时修改、增减、取消、暂停、中断或终止提供本平台全部或部分服务而无需事先告知您的权利，亦无需对您和第三方承担任何责任。服务器如因系统维护或升级而需暂停服务时，我们将尽量事先公告。如因系统维护、升级而需暂停服务或因服务器故障、硬件故障、其他不可抗力因素而导致停止服务，于暂停服务期间造成的一切不便和资料、数据等遗失，我们将尽力挽救恢复；如确实无法恢复，我们不承担任何责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          8.3我们不承担由于您提供信息而可能产生的任何责任，包括但不限于因您在没有获得授权的情形下使用信息，或因您提供信息包含错误、不准确、病毒、诽谤、中伤、侵权等著作权法、隐私和个人信息保护相关法律或其他任何法律所禁止的内容或其他内容而产生的任何责任。我们亦不对您提供的信息在任何情形下的丢失、删除、移除或传输失败承担任何责任，您应对其提供信息自行保留备份。我们保留随时删除或移除任何您提供信息的权利，而无需通知您，且不需承担任何责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          8.4我们的服务内容可能含有与第三方服务的链接或接入第三方提供的服务，这些第三方仅为您提供便利，不代表我们经营或参与经营这些服务，亦不代表您被授予访问或使用这些服务的许可，您应自担责任（包括但不限于遵守该第三方的使用条款）并自付费用访问这些服务，我们不对这些服务的内容和行为负责。对于您在本平台之外，与第三方发生的任何法律行为，包括但不限于与第三方的交易，由您与该第三方自行承担全部的责任，我们并不控制或支持此类交易，因此我们不承担任何责任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          8.5由于我们提供的产品和服务具有一定的创新性，当前的法律、法规、部门规章等规范性行文件、监管政策可能随时发生变化并对我们提供的产品和服务产生重大影响。您知悉并同意，我们无法保证向您连续提供相关服务并维持您的潮玩藏品的初始价格，我们可能会根据需要更新或调整我们的服务内容，甚至中止、终止向您提供全部或部分服务。您认可并同意，为了保障交易安全、合法、有序以及履行我们反洗钱的义务，我们有权对您的账户进行安全查询。如发现存在欺诈等异常情形，或您存在违反法律法规或本协议约定等情形，我们有权对您采取屏蔽或者限制使用等必要措施。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          8.6您特此承认并接受：对于您因使用本服务而遭受的任何直接或间接的损失，包括但不限于由于服务内容或服务的延误、不准确、错误和遗漏而产生的任何损害、责任、请求、损失或费用，我们及我们的关联方不承担任何责任。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>九、法律适用与争议解决</p>
                  <p class="desc">
                    本协议的解释和执行均适用中华人民共和国法律。倘本协议之任何规定因与中华人民共和国法律抵触而无效，则这些条款将尽可能接近本协议原条文意旨重新解析，且本协议其它规定仍应具有完整的效力及效果。如果本协议的内容与适用的强制性法律规定不一致，则以该强制性法律规定为准。
                    <span class="bold">因该协议的履行产生的任何纠纷，首先由双方协商解决；协商不成的，任何一方均可向杭州邻科娱乐科技有限公司所在地有管辖权的人民法院提起诉讼。</span>
                  </p>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>十、其他条款</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          10.1您在使用我们的服务时，根据所涉及的服务内容，可能需要同时遵守其他协议或条款。本协议及其他协议或条款，共同构成我们与您之间关于使用我们的服务的完整协议。您仅在完全同意该完整协议的前提下，方可使用该有关的服务。

                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>10.2您和我们，即杭州邻科娱乐科技有限公司，双方均是独立的主体，在任何情况下本协议不构成双方之间的代理、合伙、合营或雇佣关系。</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>10.3本协议的解释权及相关服务的解释权归杭州邻科娱乐科技有限公司所有。</p>
                      </div>
                    </li>
                    <li>

                      <div class="rt">
                        <p>10.4本协议各标题仅供参考，不作为解释条款内容的依据。</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

            </ul>
          </section>
        </article>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "about",
    mounted() {
      window.scrollTo(0, 0);
    }
  }

</script>

<style scoped="scoped">
  .contentTerms {
    background: #0C0C0C;
  }

  * {
    margin: 0;
    padding: 0;
  }

  a {
    word-break: break-all;
  }

  a:link {
    color: #5bb6fa;
  }

  /* 未被访问的链接 */
  a:visited {
    color: #935171;
  }

  /* 已被访问的链接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠标指针移动到链接上 */
  /* a:active {background:#FF704D;}  正在被点击的链接 */

  li {
    list-style: none;
  }

  .content {
    /* padding-top: 56px; */
  }

  .intro {
    color: #BDBDBD;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }

  .main {}

  .privacy-content {
    color: #83878B;
    font-size: 12px;
  }

  .privacy-content ul li {
    /* display: flex;
    align-items: flex-start; */
  }

  .privacy-content>ul>li {}

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .privacy-content ul li p {}

  .privacy-content .desc {}

  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }

</style>



// WEBPACK FOOTER //
// src/views/otheruserAgreementAndroid.vue